import {useEffect} from "react";
import {appSession, authService} from "../../commons";
import {User} from "../../commons/models/user";
import {useNavigate} from "react-router";

export default function Initialize(){
    const navigate = useNavigate();
    useEffect(() => {
        authService.getAuthUser().then(user =>{
            appSession.setUser(new User().create(user) as User);
            navigate(-1)
        });
    }, []);
    return<div>Refetching user</div>
}